import dayjs from 'dayjs';
import { ColorValues, Flex, Typography } from '@banhala/ui-kit';
import React from 'react';
import { convertToDayJs, getDayOfWeek, isNotNil } from 'shared/src/utils';
import { useRemainTimeTextFormat } from '../../../hooks/useRemainTimeTextFormat';
import { IconBrandIconThirdPL } from '../../IconBrandIconThirdPL';

export const ThirdPLDeliveryNudgeTimer: React.FC<{
  remainTime: string | null;
}> = props => {
  const { isTimeOver, text } = useRemainTimeTextFormat(props.remainTime);

  const limitTime = isNotNil(props.remainTime)
    ? convertToDayJs(props.remainTime)
    : null;

  // 23:59:59는 자정으로 취급 → 평일·토 자정 컷오프이므로 "컷오프 후" 상태가 발생하지 않음
  const isMidnight =
    isNotNil(limitTime) && limitTime.format('HH:mm:ss') === '23:59:59';

  if (isTimeOver) {
    // 평일 컷오프인 23:59:59에서 → 00:00:00 1초간 isTimeOver가 true로 잠깐 발생하는 케이스는 무시
    if (isMidnight) return null;

    const arrivalDay = dayjs().add(2, 'days');

    // 컷오프 이후 → "지금 주문하면 모레 M/D(요일) 도착"
    return (
      <Flex.Row alignItems={'center'}>
        <Typography type={'body3'} color={'content_secondary'}>
          지금 주문하면{' '}
          <Typography type={'subtitle3'} rawColor={ColorValues.pink30}>
            모레 {arrivalDay.format('M/D')}({getDayOfWeek(arrivalDay)}) 도착
          </Typography>
        </Typography>
      </Flex.Row>
    );
  }

  // 컷오프 전 → "{HH:MM:SS} 내 주문하면 내일도착"
  return (
    <Flex.Row alignItems={'center'} gap={4} margin={{ top: 1 }}>
      <Typography type={'body3'} color={'content_secondary'}>
        <Typography type={'subtitle3'} color={'content_primary'}>
          {text}
        </Typography>{' '}
        내 주문하면
      </Typography>
      <IconBrandIconThirdPL width={49} height={13} />
    </Flex.Row>
  );
};
